// React bindings for utils/backNav (2026-10-20). See backNav.js for the rules.
import { useEffect, useRef } from 'react';
import { registerBackEntry } from '../utils/backNav';

/** Hold a back entry of `kind` while `active`. `onBack()` runs when Back pops it: return 'stay' to keep the
 *  user where they are (the entry is re-armed for their next interaction), anything else to let it go. */
export function useBackEntry(active, kind, onBack) {
  const handler = useRef(onBack);
  handler.current = onBack;
  useEffect(() => {
    if (!active) return undefined;
    return registerBackEntry(kind, () => handler.current());
  }, [active, kind]);
}

/** A modal / sheet: Back closes it first (instead of leaving the screen underneath).
 *  onClose: what the modal's own close / cancel does; none = a required choice, Back is absorbed.
 *  confirmMessage: for a form, ask before discarding (never a silent discard); "no" keeps it open. */
export function useBackLayer(open, onClose, confirmMessage) {
  useBackEntry(!!open, 'layer', () => {
    if (!onClose) return 'stay';
    if (confirmMessage && !window.confirm(confirmMessage)) return 'stay';
    onClose();
    return 'done';
  });
}

export const DISCARD_FORM_MSG = 'לסגור את הטופס? מה שהוזן לא יישמר.';
